import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=422e1e7a&scoped=true&"
import script from "./ItemList.vue?vue&type=script&lang=js&"
export * from "./ItemList.vue?vue&type=script&lang=js&"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=422e1e7a&lang=scss&scoped=true&"
import style1 from "./ItemList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e1e7a",
  null
  
)

export default component.exports